import { vehicleService } from '../../helpers/services/vehicle.service';
import i18n from '@/i18n'
import router from '@/router/index'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      lastPage: 0,
      tableRowsCount: 0
    }
  },
  details: {},
  status: {}
}

export const VEHICLE_MODULE = "vehicle";

// define action 
export const GET_ALL_VEHICLES = 'getAllVehicles';
export const UPDATE_VEHICLE_STATUS = 'updateVehicleStatus';
export const GET_VEHICLE = 'getVehicle';
export const UPDATE_VEHICLE = 'updateVehicle';
export const CREATE_VEHICLE = 'createVehicle';
export const GET_VEHICLE_BY_CAR_PLATE = 'getVehicleByCarPlate';
export const LINK_VEHICLE_BY_CUSTOMER_ID = 'linkVehicleByCustomerID';
export const LINK_VEHICLE_BY_EMAIL = 'linkVehicleByEmail';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_VEHICLES_REQUEST = "getAllVehicles";
const GET_VEHICLE_REQUEST = "getVehicle";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_VEHICLES]({ commit }, { filter }) {
        vehicleService
            .getAllVehicles(filter)
            .then(
                (result) => {
                    commit(GET_ALL_VEHICLES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_VEHICLE]({ commit }, { id }) {
       await vehicleService
            .getVehicle(id)
            .then(
                (result) => {
                    commit(GET_VEHICLE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_VEHICLE]({ commit }, { data }) {
        commit(REQUEST)
        vehicleService
            .updateVehicle(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.vehicle')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_VEHICLE]({ commit }, { data }) {
        commit(REQUEST)
        vehicleService
            .createVehicle(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.vehicle')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_VEHICLE_STATUS]({ dispatch }, { filter, data }) {
        vehicleService
            .updateVehicleStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_VEHICLES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    async [GET_VEHICLE_BY_CAR_PLATE]({ commit }, { data }) {
        commit(REQUEST)
        await vehicleService
            .getVehicleByCarPlate(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(GET_VEHICLE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    [LINK_VEHICLE_BY_CUSTOMER_ID]({ commit }, { data }) {
        vehicleService
            .linkVehicleByCustomerID(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.vehicle')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    [LINK_VEHICLE_BY_EMAIL]({ commit }, { data }) {
        vehicleService
            .linkVehicleByEmail(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.vehicle')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Vehicle-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.details = {};
        state.status = { update: true, create: true };
    },
    [GET_ALL_VEHICLES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                carPlateNumber: o.car_plate_number.toUpperCase(), // not array
                isNewCar: o.is_new_car,
                previousOwnerShip: o.previous_ownership,
                detail: o.detail,
                insuranceExpiredDate: o.insurance_expired_date,
                roadTaxExpiredDate: o.road_tax_expired_date,
                needReminderRoadTax: o.need_reminder_road_tax,
                needReminderInsurance: o.need_reminder_insurance,
                insuranceAgentPhoneCode: o.insurance_agent_phone_code,
                insuranceAgentPhoneISO: o.insurance_agent_phone_iso,
                insuranceAgentPhone: o.insurance_agent_phone,
                insuranceAgentEmail: o.insurance_agent_email,
                nextReminderDate: o.next_reminder_date,
                yearBought: o.year_bought,
                yearMade: o.year_made, // not array
                carVIN: o.car_vehicle_identification_number,
                isActive: o.is_active,
                customer: o.customer,
                model: o.model,
                engineSize: o.engine_size,
                description: o.description,
                transmission: o.transmission,
                engineNumber: o.engine_number,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                createdBy: o.created_by,
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_VEHICLE_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            carPlateNumber: o.car_plate_number.toUpperCase(), // not array
            isNewCar: o.is_new_car,
            previousOwnerShip: o.previous_ownership,
            detail: o.detail,
            modelID: o.model != null ? {
                value: o.model.uuid,
                text: o.model.name
            } : '',
            insuranceExpiredDate: o.insurance_expired_date,
            roadTaxExpiredDate: o.road_tax_expired_date,
            needReminderRoadTax: o.need_reminder_road_tax,
            needReminderInsurance: o.need_reminder_insurance,
            insuranceAgentPhoneCode: o.insurance_agent_phone_code,
            insuranceAgentPhoneISO: o.insurance_agent_phone_iso,
            insuranceAgentPhone: o.insurance_agent_phone,
            insuranceAgentEmail: o.insurance_agent_email,
            nextReminderDate: o.next_reminder_date,
            yearBought: o.year_bought,
            yearMade: o.year_made, // not array
            carVIN: o.car_vehicle_identification_number,
            isActive: o.is_active,
            customer: o.customer,
            model: o.model,
            engineSize: o.engine_size,
            description: o.description,
            transmission: o.transmission,
            engineNumber: o.engine_number,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            createdBy: o.created_by,
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }
    }
}


